import { getNativeSessionToken } from '../auth/nativeSessionToken'

/** Fetches a resource with the native bearer token when one is available. */
export async function authenticatedFetch(
	input: string | URL,
	init: RequestInit = {},
): Promise<Response> {
	const headers = new Headers(init.headers)
	const token = await getNativeSessionToken()
	if (token) headers.set('Authorization', `Bearer ${token}`)
	return fetch(input, { ...init, headers })
}
